import enGB from './locales/en_GB.json'
import nlNL from './locales/nl_NL.json'

export default {
  en_GB: enGB,
  nl_NL: nlNL
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/pro4all-ui/localization/Locales.js
// module id = r4PG
// module chunks = 0